import { createServerFn } from "@tanstack/react-start"
import type { DataRegion } from "@/types/auth"

export const getRegionDetails = createServerFn({ method: "GET" }).handler(async () => {
  const region = process.env.REGION
  const availableRegionsString = process.env.AVAILABLE_REGIONS ?? "{}"
  let availableRegions: Record<string, { url: string; region: DataRegion }> = {}
  try {
    availableRegions = JSON.parse(availableRegionsString)
  } catch {}
  return {
    region,
    availableRegions,
  }
})
